import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const addToCateringCart = async (payload) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.ADD_TO_CATERING_CART, payload);
    return response.data;
  } catch (error) {
    console.error("Error adding to catering cart:", error);
    throw error;
  }
};

